/*
 * /context-suggestions (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { ContextSuggestionList } from "../../features/context-suggestions/components/context-suggestion-list"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/context-suggestions/")({
	component: ContextSuggestionsPage,
	loader: authPageLoader,
})

function ContextSuggestionsPage() {
	const { user } = Route.useLoaderData()

	const { data: suggestions, isLoading } =
		trpc.contextSuggestion.getAllByFilter.useQuery({
			where: { userId: user.id },
			sort: { column: "createdAt", direction: "desc" },
		})

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Context Suggestions"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<ContextSuggestionList
					suggestions={suggestions || []}
					isLoading={isLoading}
				/>
			</Container>
		</Page>
	)
}
